export const COOKIE_NAME = 'sprtl.ab-tests';
